import { post, apiUrl } from 'utils/apiMgmt';

const submitContact = ({ name, email, message }) =>
	post(`${apiUrl}/website/contact`, { name, email, message });

const submitQuote = (values) => post(`${apiUrl}/website/quote`, values);

export { submitContact, submitQuote };
